import { PromotionStatus } from '../contract/constants.js';
import { immutable } from '../contract/stable.js';

export function createPromotionRequest(input) {
  return immutable({
    ...input, evidenceDimensionIds: immutable([...input.evidenceDimensionIds]),
    evaluatedEvidenceIds: immutable([...(input.evaluatedEvidenceIds || [])]),
    regimeSnapshot: immutable({ ...input.regimeSnapshot }), predicateResults: immutable({ ...(input.predicateResults || {}) }),
    governanceStatus: input.governanceStatus || PromotionStatus.REQUESTED,
    quarantineStatus: input.quarantineStatus || 'CLEAR'
  });
}
